export const BRAND_NAME = "UrHR";
